/*
    Create by fanglijuan 2019-04-23
*/
"use strict";
angular.module("appNewAssociationModule", [])
    .controller("appNewAssociationCtrl", ['$scope', '$q', '$state', '$modalInstance', 'trsHttpService', "trsspliceString", "modalDialog", "params", "editingCenterService",
        function($scope, $q, $state, $modalInstance, trsHttpService, trsspliceString, modalDialog, params, editingCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    selectedPlatformVal: params.platform, //固定写死,待编的7
                    treeChnlOptions: {
                        nodeChildren: "CHILDREN",
                        dirSelectable: true,
                        allowDeselect: false,
                        injectClasses: {
                            ul: "copyDraftTree-ul",
                            li: "copyDraftTree-li",
                            liSelected: "a7",
                            iExpanded: "a3",
                            iCollapsed: "a4",
                            iLeaf: "a5",
                            label: "copyDraftTree-label",
                            labelSelected: "rolegrouplabselected"
                        },
                        isLeaf: function(node) {
                            return node.HASCHILDREN === "false";
                        },
                        totalNum: 0,
                    },
                    selectedOriginType: "wx",
                    keywords: "",
                    copyKeywords: '',
                    classObj: {
                        wx: false,
                        app: false,
                        wz: false,
                        webaudio: false,
                        webvideo: false,
                        activity: false,
                        wb: false
                    },
                    reltype: params.reltype,
                    modalTitle: params.modalTitle,
                    isSave: false,
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 10,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0
                };

            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                $scope.data = {
                    ObjectId: 0,
                    selectedCategory: {
                        id: "",
                        title: "",
                    },
                    originList: [],
                    selectedChnl: {}, // 已选择的栏目
                    selectedOrigin: {}, // 已选择的来源
                    ischeckedOriginIds: {}, // 已选择的来源id集合
                    copySelectedChnlId: "",
                    selectedObj: {//wx（微信）、app（客户端）、wz（网站）、wb（微博）、webaudio（音频）、webvideo（视频）、activity（活动）
                        'app': [],
                        'wz': [],
                        'wx': [],
                        'webaudio': [],
                        'webvideo': [],
                        'activity': [],
                        'wb': []
                    }, // 右侧确认的关联关系
                };
                getOrigin(); // 获取来源信息
                initCurrChnls(); // 获取栏目信息
            }
            /**
             * [getOrigin description] 获取来源
             * @return {[type]} [description]
             */
            function getOrigin() {
                var deffer = $q.defer();
                var params;
                $scope.data.originList = [];
                params = {
                    typeid: "zyzx",
                    serviceid: "iwo",
                    modelid: "subscription",
                    keyword: $scope.status.keywords,
                    channelName: $scope.status.selectedOriginType,
                    pageNum: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE
                };
                $scope.status.copyKeywords = params.keyword;
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    //if ($scope.status.reltype == 1) {
                    //if ($scope.status.selectedOriginType == 'app' || $scope.status.selectedOriginType == "wx" || $scope.status.selectedOriginType == 'wz') {
                        $scope.data.originList = data.content;
                    // } else {
                    //     for (var i = 0; i < data.content.length; i++) {
                    //         $scope.data.originList.push({
                    //             SOURCENAME: data.content[i].website,
                    //             CHANNEL: data.content[i].name,
                    //             HYBASEID: data.content[i].id,
                    //             SECTION: $scope.status.selectedOriginType
                    //         });
                    //     }
                    // }
                    // } else {
                    //     for (var i = 0; i < data.content.length; i++) {
                    //         $scope.data.originList.push({
                    //             CHANNEL: data.content[i].name,
                    //             HYBASEID: data.content[i].id,
                    //             SECTION: $scope.status.selectedOriginType
                    //         });
                    //     }
                    // }
                    $scope.page.CURRPAGE = data.summary_info.CURRPAGE;
                    $scope.page.ITEMCOUNT = data.summary_info.ITEMCOUNT;
                    $scope.page.PAGECOUNT = data.summary_info.PAGECOUNT;
                    deffer.resolve(data);
                });
                return deffer.promise;
            }
            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                getOrigin();
            };
            /**
             * [searchOrigin description] 搜索
             * @return {[type]} [description]
             */
            $scope.searchOrigin = function() {
                if ($scope.status.copyKeywords != $scope.status.keywords) $scope.page.CURRPAGE = 1;
                getOrigin();
            };
            /**
             * [chooseOrigin description] 选择来源分类
             * @param  {[type]} type [description] 来源分类
             * @return {[type]}      [description]
             */
            $scope.chooseOrigin = function(channel) {
                if ($scope.status.selectedOriginType == channel) return;
                $scope.status.selectedOriginType = channel;
                $scope.status.keywords = "";
                $scope.page.CURRPAGE = 1;
                getOrigin();
            };
            /**
             * [chooseOriginName description] 选择来源
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.chooseOriginName = function(item) {
                var falg = false;
                var Idx = 'id' + $scope.selectedNode.CHANNELID;
                if (!$scope.data.selectedOrigin[Idx]) {
                    $scope.data.selectedOrigin[Idx] = [];
                }
                if (!$scope.data.ischeckedOriginIds[Idx]) {
                    $scope.data.ischeckedOriginIds[Idx] = [];
                }
                for (var i = 0; i < $scope.data.selectedOrigin[Idx].length; i++) {
                    if ($scope.data.selectedOrigin[Idx][i].originId == item.HYBASEID) {
                        $scope.data.selectedOrigin[Idx].splice(i, 1);
                        $scope.data.ischeckedOriginIds[Idx].splice(i, 1);
                        falg = true;
                        break;
                    }
                }
                if (!falg) {
                    $scope.data.selectedOrigin[Idx].push({
                        originId: item.HYBASEID, // 来源ID
                        originName: item.SOURCENAME || "", // 来源名称
                        originChannel: item.CHANNEL, // 来源名称
                        section: item.SECTION, // 渠道 app website weixin
                        chnldesc: $scope.selectedNode.CHNLDESC, // 栏目名称
                        channelid: $scope.selectedNode.CHANNELID, // 栏目id
                        categorytype: $scope.status.selectedOriginType
                    });
                    $scope.data.ischeckedOriginIds[Idx].push(item.HYBASEID);
                }
            };
            /**
             * [initCurrChnls description]获取栏目信息
             * @return {[type]} [description]
             */
            function initCurrChnls() {
                editingCenterService.queryChannelsBySiteid(params.siteid, $scope.status.selectedPlatformVal).then(function(data) {
                    var flag = false;
                    $scope.data.chnlTreeData = data;
                    if (data.CHILDREN != undefined) {
                        if (data.CHILDREN.length > 0) {
                            for (var i = 0; i < data.CHILDREN.length; i++) {
                                if (data.CHILDREN[i].HASCHILDREN == 'false') {
                                    flag = true;
                                    $scope.selectedNode = data.CHILDREN[i];
                                    break;
                                }
                            }
                            if (!flag) $scope.selectedNode = data.CHILDREN[0];
                            ExpandedNodes();
                        }
                    }
                });
            }
            //默认展开树开始
            function ExpandedNodes() {
                $scope.expandedTest = [];
                $scope.expandedTest.push($scope.data.chnlTreeData);
                if ($scope.data.chnlTreeData.CHILDREN === 0) {
                    $scope.selectedNode = $scope.data.chnlTreeData;
                } else {
                    angular.forEach($scope.data.chnlTreeData.CHILDREN, function(data, index, array) {
                        if (data.ISPATH === "true") {
                            $scope.expandedTest.push(data);
                            if (data.CHILDREN.length !== 0) {
                                selfPath(data);
                            } else {
                                $scope.selectedNode = data;
                            }

                        }
                    });
                }
            }

            function selfPath(data) {
                for (var i = 0; i < data.CHILDREN.length; i++) {
                    if (data.CHILDREN[i].ISPATH === "true") {
                        if (data.CHILDREN[i].HASCHILDREN === "false" || data.CHILDREN[i].CHILDREN.length === 0) {
                            $scope.selectedNode = data.CHILDREN[i];
                            break;
                        } else {
                            $scope.expandedTest.push(data.CHILDREN[i]);
                            selfPath(data.CHILDREN[i]);
                            break;
                        }
                    }
                }
            }
            /**
             * [showChnlToggle description]树展开方法
             * @param  {[obj]} node [description]父节点
             * @return {[type]}        [description]
             */
            $scope.showChnlToggle = function(node) {
                childrenChnlTree(node, function() {});
            };
            /**
             * [childrenTree description获取子组织]
             * @param  {[type]}   node     [description]
             * @param  {Function} callback [description]
             * @return {[type]}            [description]
             */
            function childrenChnlTree(node, callback) {
                if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
                    var paramsT = {
                        "serviceid": "mlf_mediasite",
                        "methodname": "queryClassifyByChnl",
                        "channelid": node.CHANNELID,
                        "platform": $scope.status.selectedPlatformVal
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramsT, "get").then(function(dataC) {
                            node.CHILDREN = dataC.CHILDREN;
                            callback();
                        },
                        function(dataC) {
                            modalDialog.alertType("错误提示", "获取子栏目失败", "warning", false, function() {});
                        });
                }
            }
            //判断是否选中栏目
            $scope.chooseChnl = function(node) {
                $scope.data.copySelectedChnlId = 'id' + $scope.selectedNode.CHANNELID;
                $scope.selectedNode = node;
                var newIdx = 'id' + node.CHANNELID;
                if (!!$scope.data.selectedOrigin[$scope.data.copySelectedChnlId]) {
                    $scope.data.selectedOrigin[newIdx] = $scope.data.selectedOrigin[$scope.data.copySelectedChnlId];
                    for (var i = 0; i < $scope.data.selectedOrigin[newIdx].length; i++) {
                        $scope.data.selectedOrigin[newIdx][i].chnldesc = $scope.selectedNode.CHNLDESC; // 栏目名称
                        $scope.data.selectedOrigin[newIdx][i].channelid = $scope.selectedNode.CHANNELID; // 栏目id
                    }
                    delete $scope.data.selectedOrigin[$scope.data.copySelectedChnlId];
                }

                if (!!$scope.data.ischeckedOriginIds[$scope.data.copySelectedChnlId]) {
                    $scope.data.ischeckedOriginIds[newIdx] = $scope.data.ischeckedOriginIds[$scope.data.copySelectedChnlId];
                    delete $scope.data.ischeckedOriginIds[$scope.data.copySelectedChnlId];
                }
            };
            /**
             * [relation description] 关联
             * @return {[type]} [description]
             */
            $scope.relation = function() {
                var Idx = 'id' + $scope.selectedNode.CHANNELID;
                if (!$scope.data.selectedOrigin[Idx] || $scope.data.selectedOrigin[Idx].length <= 0) {
                    modalDialog.alertType("请选择来源", "", "error", false);
                    return;
                }
                $scope.status.totalNum = 0;
                angular.forEach($scope.data.selectedOrigin[Idx], function(value, k2) {
                    var inArray = false;
                    var channelid = value.channelid;
                    for (var i = 0; i < $scope.data.selectedObj[value.section].length; i++) {
                        if ($scope.data.selectedObj[value.section][i].channelid == channelid && $scope.data.selectedObj[value.section][i].originId == value.originId) {
                            inArray = true;
                            break;
                        }
                    }
                    if (!inArray) {
                        $scope.data.selectedObj[value.section].push({
                            originId: value.originId, // 来源ID
                            originName: value.originName, // 来源名称
                            originChannel: value.originChannel, // 来源名称
                            section: value.section, // 渠道 app website weixin
                            chnldesc: value.chnldesc, // 栏目名称
                            channelid: value.channelid, // 栏目id
                            categorytype: value.categorytype
                        });
                    }

                });

                angular.forEach($scope.data.selectedObj, function(v, k) {
                    $scope.status.totalNum += v.length;
                });
                $scope.status.classObj[$scope.status.selectedOriginType] = $scope.status.selectedOriginType; //展开右侧
                $scope.data.selectedOrigin = {};
                $scope.data.ischeckedOriginIds = {};
            };
            /**
             * [removeSelectedItem description] 删除已选择的关联
             * @param  {[type]} key  [description]
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.removeSelectedItem = function(key, item) {
                var index = $scope.data.selectedObj[key].indexOf(item);
                $scope.data.selectedObj[key].splice(index, 1);
                $scope.status.totalNum--;
            };
            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                var submitObj = [];
                var hasData = false;
                angular.forEach($scope.data.selectedObj, function(value, key) {
                    if (value.length > 0) {
                        hasData = true;
                    }
                    for (var i = 0; i < value.length; i++) {
                        var obj = {
                            CHANNELID: value[i].channelid,
                            categoryid: value[i].originId,
                            categorytype: value[i].categorytype,
                            categoryname: key != 'wx' && key != 'wb' ? value[i].originName + " | " + value[i].originChannel : key == 'wx' || key == 'wb' ? value[i].originName : value[i].originChannel
                        };
                        submitObj.push(obj);
                    }
                });
                if (!hasData) {
                    modalDialog.alertType("请选择关联关系", "", "error", false);
                    return;
                }
                if ($scope.status.isSave) return;
                var param = {
                    serviceid: "mlf_appquickpublish",
                    methodname: "saveRels",
                    SITEID: params.siteid,
                    reltype: $scope.status.reltype,
                    CATEGORYINFO: JSON.stringify(submitObj)
                };
                $scope.status.isSave = true;
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), param, 'post').then(function(data) {
                    $modalInstance.close(data);
                }, function(res) {
                    $modalInstance.close('success');
                });
            };
            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);